<template>
  <div class="contact-item" v-if="contactItem">
    <router-link class="d-flex align-items-center py-2" :to="pathTo">
      <div class="flex-shrink-0 me-2 me-lg-4">
        <div v-if="contactItem.image">
          <div class="img-rounded img-profile my-2" v-bind:style="{'backgroundImage': (contactItem.thumb) ? 'url('+ publicPath + contactItem.thumb +')' : ''}"></div>
        </div>
        <div v-if="!contactItem.image">
          <div class="img-rounded my-2">
            <i class="fa fa-user"></i>
          </div>
        </div>
      </div>
      <div class="flex-grow-1">
        <h3>{{ contactItem.title }}</h3>
        <div class="profile-info">
          <span v-if="contactItem.company" class="font-bold">{{ contactItem.company }} -</span> 
          <span v-if="contactDetails && contactDetails.unit" class="font-bold">{{ contactDetails.unit }}</span> 
          <span v-if="contactItem.country" class="font-bold">({{ contactItem.country }})</span>
          <span v-if="contactDetails && contactDetails.role"><br>{{ contactDetails.role }}</span>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'ContactListItem',
  props: ['contactItem', 'page', 'eventItem', 'pathTo', 'menuClass'],
  computed: {
    contactDetails() {
      if (this.page === 'staff' && this.contactItem.staff) return this.contactItem.staff.find(userItem => userItem.fairId === Number(this.eventItem.id))
      if (this.page === 'participants' && this.contactItem.participants) return this.contactItem
      return null
    }
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  }
}
</script>

<style>
</style>

<style scoped>
.contact-item {
  border-top: 1px solid #DDDDDD;
  text-align: center;
}
.contact-item:last-child {
  border-bottom: 1px solid #DDDDDD;
}

.contact-item a {
  text-decoration: none;
  color: inherit;
}

.img-rounded {
  width: 80px;
  height: 80px;
  border-radius: 40px;
}
.img-rounded > i {
  font-size: 60px;
  line-height: 70px;
}
.profile-info span {
  font-size: smaller;
}
</style>
